<template>

  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="招标项目分类">
              <j-tree-select
                ref="treeSelect"
                placeholder="请选择招标项目类别"
                dict="sys_category,name,code"
                pidField="pid"
                pidValue="A01"
                hasChildField="1"
                v-model="queryParam.tenderCode1"
                @change="changeIndustries"
              >
              </j-tree-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="招标项目编号">
              <j-input placeholder="请输入招标项目编号" v-model="queryParam.tenderProjectCode"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item label="招标项目名称">
              <j-input placeholder="请输入招标项目名称" v-model="queryParam.tenderProjectName"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="招标项目状态">
              <j-dict-select-tag
                placeholder="请选择招标项目状态"
                dictCode="bid_project_status"
                v-model="queryParam.status"
              />
            </a-form-item>
          </a-col>

          <a-col :span="4">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <span slot="action" slot-scope="text, record">
          <a @click="showSectionIdsSelect(record.id)">服务评价</a>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <!--  标段选择组件  -->
    <section-ids-select ref="sectionIdsSelect"
                        :closable="true"
                        @showAssessmentForm="showAssessmentForm">
    </section-ids-select>
    <!-- 服务评价表单 -->
    <assessment-modal v-if="showAssessmentFormSign"
                      @closeAssessment="closeAssessment"
                      :assessmentParam="assessmentParam"
                      :evalTargetList="evalTargetList">
    </assessment-modal>
  </a-card>

</template>

<script>
import {FzisListMixin} from '@/mixins/FzisListMixin'
import SectionIdsSelect from "@comp/tools/SectionIdsSelect";
import AssessmentModal from "@views/ebid/modules/AssessmentModal";

export default {
  name: "CheckEval",
  mixins: [FzisListMixin],
  components: {
    SectionIdsSelect,
    AssessmentModal,
  },
  data() {
    return {
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '招标项目分类',
          align: 'left',
          width: 150,
          dataIndex: 'tenderProjectClassifyName'
        },
        {
          title: '招标项目编号',
          align: 'left',
          dataIndex: 'tenderProjectCode',
          width: 120,
        },
        {
          title: '招标项目名称',
          align: 'left',
          dataIndex: 'tenderProjectName',
          scopedSlots: { customRender: 'projectTitle' },
        },
        /*{
          title: '项目编号',
          align: 'left',
          dataIndex: 'projectCode'
        },*/
        {
          title: '评标办法',
          align: 'center',
          width: 110,
          dataIndex: 'bidEvaluationWay'
        },
        {
          title: '电子标',
          align: 'center',
          dataIndex: 'isElect',
          width: 60,
          customRender: function(text) {
            if (text == "0") {
              return '否'
            } else if (text == "1") {
              return '是'
            }  else {
              return text
            }
          }
        },
        {
          title: '流程环节',
          align: 'center',
          dataIndex: 'wfName',
          width: 100,
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          width: 70,
          customRender: function(text) {
            if (text == 0) {
              return '正常'
            } else if (text == 1) {
              return '挂起'
            } else if (text == 2) {
              return '终止'
            }else {
              return text
            }
          }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 100,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/ebid-ce/tmBidProject/checkEvalList',
      },
      showAssessmentFormSign: false,
      assessmentParam: {},
      evalTargetList: ['ebid_agency', 'expert'],
    }
  },
  methods: {
    changeIndustries(value){
      this.queryParam.tenderProjectClassifyCode = value + "*";
    },
    showSectionIdsSelect(bid) {
      this.$refs.sectionIdsSelect.show(bid)
    },
    showAssessmentForm(param) {
      this.showAssessmentFormSign = true;
      this.assessmentParam = param
    },
    closeAssessment() {
      this.showAssessmentFormSign = false;
    }
  },
}
</script>

<style scoped>

</style>